import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

type Props = {
  date: string;
  cycle: string;
};

export function useSettlementAdjustments(props: Props | undefined) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const query = useQuery(
    trpc.adjustments.list.queryOptions(
      {
        rentalsMerchantId: merchant?.id || "",
        settlementDate: props?.date || "",
        settlementCycle: props?.cycle || "",
      },
      {
        enabled: !!merchant?.id && !!props?.date && !!props?.cycle,
      }
    )
  );

  return {
    adjustments: query.data?.adjustments ?? [],
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
